import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
} from '@chakra-ui/react';
import MainContainer from '../../components/MainContainer';

interface ErrorFallbackProps {}

const ErrorFallback: React.FC<ErrorFallbackProps> = ({}) => {
  //  TODO: change error message
  return (
    <MainContainer>
      <Alert
        status='error'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        textAlign='center'
      >
        <AlertIcon />
        <AlertTitle>App crached</AlertTitle>
        <AlertDescription>
          Error on the app please reload the page and try again
        </AlertDescription>
      </Alert>
    </MainContainer>
  );
};

export default ErrorFallback;
